import React, { useEffect } from "react";
import AOS from "aos";
import teamwork from "../../assets/images/teamwork.png";
import reactImg from "../../assets/images/react.png";
import javaImg from "../../assets/images/java.png";
import cpp from "../../assets/images/c++.png";
import language2 from "../../assets/images/languge-2.png";
import diamond from "../../assets/images/diamond.png";
import language3 from "../../assets/images/language-3.png";
import html5 from "../../assets/images/html-5.png";
import angular from "../../assets/images/angular-lang.png";
import languge3 from "../../assets/images/languge-3.png";
import language4 from "../../assets/images/language-4.png";
import php from "../../assets/images/php.png";
import mongo from "../../assets/images/mongo.png";
import node from "../../assets/images/node.png";
import usImg from "../../assets/images/us.png";
import uxImg from "../../assets/images/ux.png";
import triffle from "../../assets/images/trifle-icon.png";
import unity from "../../assets/images/unity.png";
import amasone from "../../assets/images/aws.png";

function BoostBusiness(props) {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id="Boostupbusiness" className="boost-section">
      {/* model */}
      <div
        className="modal fade"
        id="languageModal"
        tabindex="-1"
        aria-labelledby="languageModalModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>React</h1>
                <p>
                  A free and open-source front-end JavaScript library for
                  building user interfaces or UI components. It is maintained by
                  Facebook and a community of individual developers and
                  companies. React can be used as a base in the development of
                  single-page or mobile applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="nodejsModal"
        tabindex="-1"
        aria-labelledby="nodejsModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Nodejs</h1>
                <p>
                  An open source development platform for executing JavaScript
                  code server-side. Node is useful for developing applications
                  that require a persistent connection from the browser to the
                  server and is often used for real-time applications such as
                  chat, news feeds and web push notifications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="fluterModal"
        tabindex="-1"
        aria-labelledby="fluterModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Flutter</h1>
                <p>
                  A cross-platform UI toolkit that is designed to allow code
                  reuse across operating systems such as iOS and Android, while
                  also allowing applications to interface directly with
                  underlying platform services. ... An introduction to widgets:
                  The fundamental building blocks of Flutter user interfaces.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="userExperienceModel"
        tabindex="-1"
        aria-labelledby="userExperienceModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>User Experience</h1>
                <p>
                  The process design teams use to create products that provide
                  meaningful and relevant experiences to users. This involves
                  the design of the entire process of acquiring and integrating
                  the product, including aspects of branding, design, usability
                  and function.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="golangModel"
        tabindex="-1"
        aria-labelledby="golangModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>User Experience</h1>
                <p>
                  The process design teams use to create products that provide
                  meaningful and relevant experiences to users. This involves
                  the design of the entire process of acquiring and integrating
                  the product, including aspects of branding, design, usability
                  and function.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="jQueryModel"
        tabindex="-1"
        aria-labelledby="jQueryModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>JQuery </h1>
                <p>
                  a JavaScript library designed to simplify HTML DOM tree
                  traversal and manipulation, as well as event handling, CSS
                  animation, and Ajax. It is free, open-source software using
                  the permissive MIT License
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="laravelModel"
        tabindex="-1"
        aria-labelledby="laravelModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Laravel </h1>
                <p>
                  An open-source PHP framework, which is robust and easy to
                  understand. It follows a model-view-controller design pattern.
                  Laravel reuses the existing components of different frameworks
                  which helps in creating a web application. The web application
                  thus designed is more structured and pragmatic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="unityModel"
        tabindex="-1"
        aria-labelledby="unityModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Unity </h1>
                <p>
                  A theoretical language which focuses on what, instead of
                  where, when or how. The language contains no method of flow
                  control, and program statements run in a nondeterministic way
                  until statements cease to cause changes during execution. This
                  allows for programs to run indefinitely, such as auto-pilot or
                  power plant safety systems, as well as programs that would
                  normally terminate (which here converge to a fixed point).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="amasoneModel"
        tabindex="-1"
        aria-labelledby="amasoneModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>AWS </h1>
                <p>
                  A comprehensive, evolving cloud computing platform provided by
                  Amazon that includes a mixture of infrastructure as a service
                  (IaaS), platform as a service (PaaS) and packaged software as
                  a service (SaaS) offerings.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="angularModel"
        tabindex="-1"
        aria-labelledby="angularModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Angular JS </h1>
                <p>
                  A structural framework for dynamic web applications. It lets
                  you use HTML as your template language and lets you extend
                  HTML's syntax to express your application components clearly
                  and succinctly. Its data binding and dependency injection
                  eliminate much of the code you currently have to write.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="html5Model"
        tabindex="-1"
        aria-labelledby="html5Model"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>HTML5 </h1>
                <p>
                  A markup language used for structuring and presenting content
                  on the World Wide Web.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="MongodbModel"
        tabindex="-1"
        aria-labelledby="html5Model"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Mongodb</h1>
                <p>
                  An open source NoSQL database management program. NoSQL is
                  used as an alternative to traditional relational databases.
                  ... MongoDB is a tool that can manage document-oriented
                  information, store or retrieve information. MongoDB supports
                  various forms of data.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="cModal"
        tabindex="-1"
        aria-labelledby="cModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>C++</h1>
                <p>
                  A statically typed, compiled, general-purpose, case-sensitive,
                  free-form programming language that supports procedural,
                  object-oriented, and generic programming. C++ is regarded as a
                  middle-level language, as it comprises a combination of both
                  high-level and low-level language features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="rubyModal"
        tabindex="-1"
        aria-labelledby="rubyModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Ruby</h1>
                <p>
                  An interpreted, high-level, general-purpose programming
                  language. It was designed and developed in the mid-1990s by
                  Yukihiro "Matz" Matsumoto in Japan. Ruby is dynamically typed
                  and uses garbage collection and just-in-time compilation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="pythonModel"
        tabindex="-1"
        aria-labelledby="pythonModel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Python</h1>
                <p>
                  An interpreted, object-oriented, high-level programming
                  language with dynamic semantics. ... Python's simple, easy to
                  learn syntax emphasizes readability and therefore reduces the
                  cost of program maintenance. Python supports modules and
                  packages, which encourages program modularity and code reuse
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="phpmodel"
        tabindex="-1"
        aria-labelledby="phpmodel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>PHP</h1>
                <p>
                  A server side scripting language that is embedded in HTML. It
                  is used to manage dynamic content, databases, session
                  tracking, even build entire e-commerce sites. It is integrated
                  with a number of popular databases, including MySQL,
                  PostgreSQL, Oracle, Sybase, Informix, and Microsoft SQL
                  Server.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="javaModal"
        tabindex="-1"
        aria-labelledby="javaModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>Java</h1>
                <p>
                  Object-oriented programming language that produces software
                  for multiple platforms. When a programmer writes a Java
                  application, the compiled code (known as bytecode) runs on
                  most operating systems (OS), including Windows, Linux and Mac
                  OS.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="netmodel"
        tabindex="-1"
        aria-labelledby="netmodel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body model-iner-content d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h1>.net</h1>
                <p>
                  A framework that provides programming guidelines that can be
                  used to develop a wide range of applications–––from web to
                  mobile to Windows-based applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="container">
        <div className="d-flex justify-content-center align-items-center">
          <div className="heading">
            <h2
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-easing="ease-out-cubic"
              class="aos-init aos-animate"
            >
              Use DevTeamSix Skills &amp;
            </h2>
            <h1
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-easing="ease-out-cubic"
              class="aos-init aos-animate"
            >
              Boost Your Business
            </h1>
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6 col-md-12 order-1 order-lg-0">
            <div className="teamwork">
              <div
                data-aos="fade-right"
                data-aos-duration="1500"
                data-aos-easing="ease-out-cubic"
                class="aos-init aos-animate"
              >
                <img src={teamwork} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 order-0 order-lg-1">
            <div className="languages-types">
              <div className="react">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#languageModal"
                  >
                    <img src={reactImg} alt="" />
                  </a>
                </div>
              </div>
              <div className="java">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#javaModal"
                  >
                    <img src={javaImg} alt="" />
                  </a>
                </div>
              </div>
              <div className="c">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#cModal"
                  >
                    <img src={cpp} alt="" />
                  </a>
                </div>
              </div>
              <div className="languge-2">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#jQueryModel"
                  >
                    <img src={language2} alt="" />
                  </a>
                </div>
              </div>
              <div className="diamond">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#rubyModal"
                  >
                    <img src={diamond} alt="" />
                  </a>
                </div>
              </div>
              <div className="logimg-3">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#pythonModel"
                  >
                    <img src={language3} alt="" />
                  </a>
                </div>
              </div>
              <div className="html-5">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#html5Model"
                  >
                    <img src={html5} alt="" />
                  </a>
                </div>
              </div>
              <div className="angular-lang">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#angularModel"
                  >
                    <img src={angular} alt="" />
                  </a>
                </div>
              </div>
              <div className="languge-3">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#fluterModal"
                  >
                    <img src={languge3} alt="" />
                  </a>
                </div>
              </div>
              <div className="language-4">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#golangModel"
                  >
                    <img src={language4} alt="" />
                  </a>
                </div>
              </div>
              <div className="language-php">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#phpmodel"
                  >
                    <img src={php} alt="" />
                  </a>
                </div>
              </div>
              <div className="mongo">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#MongodbModel"
                  >
                    <img src={mongo} alt="" />
                  </a>
                </div>
              </div>
              <div className="node">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#netmodel"
                  >
                    <img src={node} alt="" />
                  </a>
                </div>
              </div>
              <div className="us">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#nodejsModal"
                  >
                    <img src={usImg} alt="" />
                  </a>
                </div>
              </div>
              <div className="ux-img">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#userExperienceModel"
                  >
                    <img src={uxImg} alt="" />
                  </a>
                </div>
              </div>
              <div className="trifle">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#laravelModel"
                  >
                    <img src={triffle} alt="" />
                  </a>
                </div>
              </div>
              <div className="unity">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#unityModel"
                  >
                    <img src={unity} alt="" />
                  </a>
                </div>
              </div>
              <div className="amasone">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-cubic"
                  class="aos-init aos-animate"
                >
                  <a
                    type="button"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#amasoneModel"
                  >
                    <img src={amasone} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default BoostBusiness;
